module.exports = __webpack_public_path__ + "img/fown.644e7628.png";